/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Yes_BodyInputs */

const en_landing_how_yes_body = /** @type {(inputs: Landing_How_Yes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most sessions confirm on the spot.`)
};

const pl_landing_how_yes_body = /** @type {(inputs: Landing_How_Yes_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Większość zajęć potwierdza się od razu.`)
};

/**
* | output |
* | --- |
* | "Most sessions confirm on the spot." |
*
* @param {Landing_How_Yes_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_yes_body = /** @type {((inputs?: Landing_How_Yes_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Yes_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_yes_body(inputs)
	return en_landing_how_yes_body(inputs)
});